var map = {
	"./Orpea_Logo.png": "4194",
	"./Serenitas.png": "b891",
	"./animacare.png": "77f4",
	"./armonea.png": "41ff",
	"./domidep.png": "849a",
	"./enjoylife.png": "0186",
	"./noble-age.png": "53f0",
	"./novadia.png": "f58c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2014";